import classNames from 'classnames'
import { ReactNode } from 'react'
import Card from 'react-bootstrap/Card'

import OutboundLink from '@/components/OutboundLink/OutboundLink'
import usePatreonTier from '@/utils/usePatreonTier'

import styles from './PleaseSupportUs.module.scss'

type Props = {
  always?: boolean
  children?: ReactNode
  className?: string
  height?: number
  rare?: boolean
  width?: number
}

const PleaseSupportUs = ({ children, className, height, rare, width }: Props) => {
  const patreonTier = usePatreonTier()

  if ((patreonTier && !rare) || patreonTier === 'rare') {
    return null
  }

  return (
    <Card className={classNames(styles.insetBorder, 'shadow-sm', className)}>
      <div
        className={styles.container}
        style={{
          height: height || 200,
          width: width || 'auto',
        }}
      >
        <OutboundLink url='https://patreon.com/edhrec' utm_medium='please_support_us'>
          {children || 'Please consider supporting us on Patreon to remove ads for only $2/month.'}
        </OutboundLink>
      </div>
    </Card>
  )
}

export default PleaseSupportUs
